import { CosmeticStatus } from '@profile/src/utils/types';
export const sortOptions = [{
  label: 'All items',
  dataTestId: 'all'
}, {
  id: 'selected',
  label: 'Selected',
  dataTestId: 'selected'
}, {
  id: CosmeticStatus.AVAILABLE.toString(),
  label: 'Available',
  dataTestId: 'available'
}, {
  id: CosmeticStatus.SELLING.toString(),
  label: 'Selling',
  dataTestId: 'selling'
}, {
  id: [CosmeticStatus.MINTING, CosmeticStatus.USER_MINTING].join(','),
  label: 'Processing',
  dataTestId: 'processing'
}, {
  id: [CosmeticStatus.NOT_MINT, CosmeticStatus.USER_NOT_MINT].join(','),
  label: 'Not mint',
  dataTestId: 'not-mint'
}];